/**
 * <TextItem
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import Dropzone from 'react-dropzone';
import ImageCropper from 'template/Modals/ImageCropper';
import uploadPicture from 'controllers/poster/uploadPicture'
import { alert } from 'util/alert';
import { sortable } from 'react-sortable';
import locale from './locale'

const ACCEPT_MIME = 'image/png,image/jpeg';
const MAX_SIZE = 5 * 1000 * 1000;
const MIN_SIZE = 0;

class Item extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.selectImage = this.selectImage.bind(this);
  }

  componentWillMount() {

  }

  selectImage(accepted, rejected){

    if (rejected.length > 0) {
      alert.warning(__('Image file must be png/jpeg under 5 MB', 'image'), __('Image not qualified', 'image'));
      return;
    } else if (accepted.length === 0) {
      alert.warning('', __('No Image Selected'));
      return;
    }

    ImageCropper({
      file: accepted[0]
    })
    .then(({ file, imageUrl, dataUrl })=>{
      let {addItem, posterId} = this.props

      if (file) {
        this.setState({
          creating: true,
        });

        uploadPicture(posterId, file)
          .then((res) => {
            addItem('picture', {
              image_url: res.save_to,
            });

            // STEP 3. CREATING COMPLETE
            this.setState({
              creating: false,
            });
          });
      }

    })
    .catch((err)=>{

    });
  }

  render() {
    const { item, addItem, removeItem, onClick, showAddOption } = this.props;
    const { text, content_type, image_url, index } = item;

    let contentText = (index === 1 && text === '') ? `<p>${__('Please start to edit your poster at right side editor', locale)}</p>` : text;

    const Content = (
      <div className='PreviewContent' data-qr-json={JSON.stringify(item)}>
        { content_type === 'picture' &&
          <img src={image_url} className='PosterEditItemBg'/>
        }
        <a>
          <Dropzone
            accept={ACCEPT_MIME}
            multiple={false}
            className='zone'
            maxSize={MAX_SIZE}
            minSize={MIN_SIZE}
            onDrop={this.selectImage}
          />
        </a>

        <i className='DeleteButton fa icon-trash' onClick={removeItem}></i>
        { content_type == 'text' && <div className='text-section' dangerouslySetInnerHTML={{__html: contentText}}></div> }
      </div>
    );

    return (
      <div>
        <li className={classnames('PosterEditItem', { "active": showAddOption[item.id] == true })} {...this.props} >
          {Content}
        </li>
        {showAddOption[item.id] && <div className='text-center add-btn-container'>
          <i className='fa icon-font' onClick={()=>{ addItem('text'); }}></i>
          <a className='image-btn'>
            <Dropzone
              accept={ACCEPT_MIME}
              multiple={false}
              className='zone'
              maxSize={MAX_SIZE}
              minSize={MIN_SIZE}
              onDrop={this.selectImage}
              children={(
                <div className='add-item-btn'>
                  <i className='fa icon-picture'></i>
                </div>
              )}
            />
          </a>
        </div>}

      </div>
    )
  }
}

export default sortable(Item);



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/EditPoster/Item.js